module.exports = __webpack_public_path__ + "static/media/Ivan_Jutamulia_Resume.eedac231.pdf";